module.exports = __webpack_public_path__ + "static/media/checkmark-orange.17a1f976.svg";